define.alias("shared/components/shared/trial-countdown", "settings/components/shared/trial-countdown");